import { defineComponent, openBlock, createBlock, unref, withCtx, createTextVNode } from 'vue';
import '@ssml-editor/vue';
import { ElButton } from 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "submit-menu",
  props: {
    onClick: { type: Function },
    editor: {},
    config: {}
  },
  setup(__props) {
    async function submitHandler() {
      __props.onClick && __props.onClick(__props.editor, __props.config);
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(ElButton), {
        type: "primary",
        onClick: submitHandler
      }, {
        default: withCtx(() => [
          createTextVNode("提交")
        ]),
        _: 1
      });
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=submit-menu.vue.js.map
